import { render, staticRenderFns } from "./SitemapSection.vue?vue&type=template&id=b032c112&scoped=true&"
import script from "./SitemapSection.vue?vue&type=script&lang=js&"
export * from "./SitemapSection.vue?vue&type=script&lang=js&"
import style0 from "./SitemapSection.vue?vue&type=style&index=0&id=b032c112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b032c112",
  null
  
)

export default component.exports